import api from "app/api";
import { useEffect, useState } from "react";

export default function useNotifyCount() {
  const [count, setCount] = useState(0);
  async function loadNotifyCount() {
    const { success, data, error } = await api.get("/bookings/notify-count");
    if (success) {
      setCount(data?.count || 0);
    }
  }

  useEffect(() => {
    loadNotifyCount();
  }, []);
  return count;
}
